import { render, staticRenderFns } from "./myNotice.vue?vue&type=template&id=63bf1e00&scoped=true"
import script from "./myNotice.vue?vue&type=script&lang=js"
export * from "./myNotice.vue?vue&type=script&lang=js"
import style0 from "./myNotice.vue?vue&type=style&index=0&id=63bf1e00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bf1e00",
  null
  
)

export default component.exports